export default class DatetimeExtend {

  date: Date;

  constructor(date: Date = new Date()) {
    this.date = date;
  }

  getFullMinutes(): string {
    let minute = this.date.getMinutes().toString();
    if (minute.length === 1) minute = '0' + minute;
    return minute;
  }

  getFullHours(): string {
    let hour = this.date.getHours().toString();
    if (hour.length === 1) hour = '0' + hour;
    return hour;
  }

  // Renvoie de 1 à 31
  getFullDate(): string {
    let day = this.date.getDate().toString();
    if (day.length === 1) day = '0' + day;
    return day;
  }

  // Renvoie de 1 à 12
  getFullMonth(): string {
    let month = (this.date.getMonth() + 1).toString();
    if (month.length === 1) month = '0' + month;
    return month;
  }

  getFullYear(): string {
    return this.date.getFullYear().toString();
  }
}
